import { RegistrationStatusReason } from './RegistrationStatusReason'

export const ActionableRegistrationStatusReasons = [
  RegistrationStatusReason.ITEMS_EXPIRED,
  RegistrationStatusReason.ITEMS_EXPIRING,
  RegistrationStatusReason.AWAIT_CERT_OR_DOC,
  RegistrationStatusReason.AWAITING_CANDIDATE_ACTION,
]
